module.exports = __webpack_public_path__ + "img/under-maintenance.67aec374.svg";